var render = function render(){var _vm=this,_c=_vm._self._c;return _c('roughness-template',{attrs:{"skin-roughness":_vm.skinRoughness,"skin-roughness-ai-selected":_vm.skinRoughnessAiSelected,"exfoliate-skin":_vm.exfoliateSkin,"chemical-peeling":_vm.chemicalPeeling,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }